import React from "react";
import "./Onboarding.css"
import "./Step2.css";

export default function Step2Download() {
  const downloadFile = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop();
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const files = [
    { name: "Vendor Insurance & Indemnity Declaration", url: "/files/summer/2026_Participant Agreement & Indemnity_Bizarre Bazaar Christmas Festival.pdf", emoji: "📄" },
    { name: "Vendor Participant Agreement & Indemnity", url: "/files/summer/2026_Vendor Insurance & Indemnity Declaration_Bizarre Bazaar Christmas Festival.pdf", emoji: "📄" },
  ];

  return (
    <div className="onboarding-step">
      <h3>Step 2: Download Forms</h3>
      <p>
        <ol className="alpha-list">
          <li>Download the two forms below.</li>
          <li> Review both documents carefully.</li>
          <li>Sign where indicated.</li>
          <li>Upload the signed copies in the next step - Step 3</li>
        </ol>
      </p>

      <div className="download-container">
        {files.map(file => (
          <button
            key={file.name}
            className="download-btn"
            onClick={() => downloadFile(file.url)}
          >
            <span className="emoji">{file.emoji}</span> {file.name}
          </button>
        ))}
      </div>
    </div>
  );
}

